import { createSlice } from "@reduxjs/toolkit";

export const buttonClickSlice = createSlice({
    name: "saturnClick",
    initialState: {
        saturnClickflag: false,
        earthClickflag: false,
        jupiterClickflag: false,
        uranusClickflag: false,
        saturnInitialValue: 0,
        earthInitialValue: 0,
        jupiterInitialValue: 0,
        uranusInitialValue: 0,
    },
    reducers: {
        saturnClicked: (state) => {
            state.saturnClickflag = true;
            state.earthClickflag = false;
            state.jupiterClickflag = false;
            state.uranusClickflag = false;
            state.saturnInitialValue += 1;
        },
        earthClicked: (state) => {
            state.earthClickflag = true;
            state.jupiterClickflag = false;
            state.saturnClickflag = false;
            state.uranusClickflag = false;
            state.earthInitialValue += 1;
        },
        jupiterClicked: (state) => {
            state.jupiterClickflag = true;
            state.earthClickflag = false;
            state.saturnClickflag = false;
            state.uranusClickflag = false;
            state.jupiterInitialValue += 1;
        },
        uranusClicked: (state) => {
            state.uranusClickflag = true;
            state.earthClickflag = false;
            state.jupiterClickflag = false;
            state.saturnClickflag = false;
            state.uranusInitialValue += 1;
        },
        returnClicked: (state) => {
            state.saturnClickflag = false;
            state.earthClickflag = false;
            state.jupiterClickflag = false;
            state.uranusClickflag = false;
        },
    },
});

export const { saturnClicked, earthClicked, jupiterClicked, returnClicked, uranusClicked } = buttonClickSlice.actions;
export default buttonClickSlice.reducer;
